import Localization from '@localization/Index';
import { intervalToDuration } from 'date-fns';

/**
 * Converte una durata in millisecondi nel formato: "X giorni, Y ore, Z minuti, W secondi"
 * @param ms - Durata in millisecondi
 * @returns Una stringa formattata
 */
export const formatDurationFromMilliseconds = (ms: number) => {
    if (ms === 0) return `0 ${Localization.DATE_UTILS.MILLISECONDI(0)}`;
    const duration = intervalToDuration({
        start: 0,
        end: ms
    });

    const parts = [];

    if (duration.days) parts.push(`${duration.days} ${Localization.DATE_UTILS.GIORNI(duration.days)}`);
    if (duration.hours) parts.push(`${duration.hours} ${Localization.DATE_UTILS.ORE(duration.hours)}`);
    if (duration.minutes) parts.push(`${duration.minutes} ${Localization.DATE_UTILS.MINUTI(duration.minutes)}`);
    if (duration.seconds) parts.push(`${duration.seconds} ${Localization.DATE_UTILS.SECONDI(duration.seconds)}`);

    // Se tutte le parti sono 0
    if (parts.length === 0) return `${ms} ${Localization.DATE_UTILS.MILLISECONDI(ms)}`;

    return parts.join(', ');
}
